import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DesignationList from "./DesignationsList";
import DesignationCreate from "./DesignationCreate";
import ProtectedRoutes from "components/common/routing/ProtectedRoutes";

const DesignationsIndex = () => {
  return (
    <Routes>
      <Route index element={
        <ProtectedRoutes permissionKey="Designation-view">
          <DesignationList />
        </ProtectedRoutes>
      } />

      <Route path="create" element={
        <ProtectedRoutes permissionKey="Designation-manage">
          <DesignationCreate />
        </ProtectedRoutes>
      } />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};

export default DesignationsIndex;
